import * as React from "react";
import { Column } from "primereact/column";
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Button } from "reactstrap";
import { Link } from "react-router-dom";
import PageLayout from "../../components/PageLayout";
import useEntitiesList from "../../utils/listHookNew";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DataTable } from "primereact/datatable";
import { DropdownFilterElement, renderHeader } from "../../components/TableUtils";
import Can from "../../auth/Can";
import roles from "../../auth/roles";
import { deleteCustomer } from "../../api/customers";

export default function CustomerList({ opt, activeTenant, onSelect, showAll }) {
    let dtable;

    const [result, loading, setLoading, globalFilter, setGlobalFilter, forceRefresh] = useEntitiesList("customers", "name asc", !showAll ? `tenant_id = '${activeTenant._id}'` : undefined, "");

    const [openModal, setOpenModal] = React.useState(false);
    const toggle = () => setOpenModal(!openModal);

    const onDelete = async id => {
        const value = await deleteCustomer(id);
        toggle();
        forceRefresh();
        return value;
    };

    const modalSection = () => (
        <Modal zIndex={2000} centered size="sm" isOpen={openModal ? true : false} backdrop={true}>
            <ModalHeader toggle={toggle}>
                Eliminazione Cliente
        </ModalHeader>
            <ModalBody>
                <p>Confermi di voler eliminare il Cliente {openModal.name}?</p>
            </ModalBody>
            <ModalFooter>
                <Button color="link" className="btn-link-dark" onClick={toggle}>Annulla</Button>{' '}
                <Button color="danger" className="ml-auto" onClick={() => onDelete(openModal._id)}>Elimina</Button>
            </ModalFooter>
        </Modal>
    );

    const getHeader = () => {
        if (onSelect || showAll) return null;
        return (
            <Can
                roles={[roles.DEALER, roles.VENDITORE, roles.ADMIN, roles.BACKOFFICE]}
                yes={() =>
                    <div className="action-container">
                        <Link
                            title="Aggiungi cliente azienda"
                            className="btn btn-primary p-button-icon-only"
                            to={`add-customer`}
                        >
                            <FontAwesomeIcon icon="user" className="mr-1" />Nuovo Cliente
                        </Link>
                    </div>
                }
                no={() => null}
            />
        );
    };

    const onRefresh = () => {
        forceRefresh();
        setGlobalFilter("");
    }

    const exportTable = () => {
        dtable.exportCSV();
    }

    return (
        <PageLayout title={`Elenco Clienti - Dealer: ${activeTenant.name}`}>
            <Row>
                <Col>
                    <DataTable

                        ref={el => {
                            dtable = el;
                        }}
                        selectionMode={onSelect ? 'single' : undefined}
                        onSelectionChange={onSelect ? onSelect : undefined}
                        loading={loading}
                        value={result}
                        rowsPerPageOptions={[5, 10, 20, 50, 100]}
                        className={`p-datatable-hoverable-rows p-datatable-customers ${onSelect ? "p-datatable-pointer" : null}`}
                        responsive
                        paginator={true}
                        autoLayout={false}
                        first={0}
                        rows={20}
                        totalRecords={result.length}
                        paginatorPosition="both"
                        header={renderHeader(loading, result.length, undefined, getHeader(), { globalFilter, setGlobalFilter, onRefresh }, exportTable)}
                        globalFilter={globalFilter}
                        emptyMessage={() => (<div className="text-center">Nessun Cliente in tabella</div>)}
                        paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                        currentPageReportTemplate="Visualizzati {first} di {last} Clienti su un totale di {totalRecords}"
                    >
                        <Column
                            field="name"
                            header="Cliente"
                            sortable
                            filter
                            filterMatchMode="contains"
                            style={{ wordWrap: "break-word" }}
                            body={(rowData, column) => {
                                return (
                                    !onSelect && (<Link
                                        to={`/tenant/customers/${rowData._id}`}
                                    >
                                        {rowData.name}
                                    </Link>
                                    ) ||
                                    (onSelect && (
                                        rowData.name
                                    ))
                                );
                            }}
                        />
                        {showAll && (<Column
                            field="tenant"
                            header="Dealer"
                            sortable
                            filter
                            filterMatchMode="contains"
                            style={{ wordWrap: "break-word" }}
                        />
                        )}
                        <Column
                            field="category"
                            style={{ wordWrap: "break-word" }}
                            header="Tipo cliente"
                            sortable
                            filter
                            filterElement={
                                <DropdownFilterElement
                                    field="category"
                                    options={[
                                        { label: "privato", value: "privato" },
                                        { label: "azienda", value: "azienda" }
                                    ]}
                                    onChange={e => dtable.filter(e.value, e.field)}
                                    style={{ zIndex: 1059 }}
                                />
                            }
                        />
                        <Column
                            field="taxcode"
                            header="C.F. / P.iva"
                            sortable
                            filter
                            filterMatchMode="contains"
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="email"
                            header="Email"
                            sortable
                            filter
                            filterMatchMode="contains"
                            style={{ wordWrap: "break-word" }}
                        />
                        {!onSelect && <Column
                            field="actions"
                            body={(rowData, column) => {
                                return (
                                    <div className="action-container">
                                        <Link
                                            title="Gestisci cliente"
                                            className="btn btn-sm btn-primary p-button-icon-only"
                                            to={`/tenant/customers/${rowData._id}`}
                                        >
                                            <FontAwesomeIcon icon="pencil-alt" className="mr-1" />
                                        </Link>
                                        <Link
                                            title="Aggiungi veicolo manualmente"
                                            className="btn btn-sm btn-primary p-button-icon-only"
                                            to={`/tenant/customers/${rowData._id}/add-vehicle/manually`}
                                        >
                                            <FontAwesomeIcon icon="car" className="mr-1" />
                                        </Link>
                                        <Link
                                            title="Aggiungi veicolo da targa"
                                            className="btn btn-sm btn-primary p-button-icon-only"
                                            to={`/tenant/customers/${rowData._id}/add-vehicle/from-plate`}
                                        >
                                            <FontAwesomeIcon icon="taxi" className="mr-1" />
                                        </Link>
                                        <Can
                                            roles={[roles.ADMIN]}
                                            yes={() => (
                                                <Button
                                                    color="danger"
                                                    title="Elimina cliente"
                                                    onClick={() => setOpenModal(rowData)}
                                                    className="btn-sm p-button-icon-only"
                                                >
                                                    <FontAwesomeIcon icon="trash-alt" />
                                                </Button>
                                            )}
                                            no={() => null}
                                        />
                                    </div>
                                );
                            }}
                            style={{ wordWrap: "break-word" }}
                        />}
                    </DataTable>
                </Col>
            </Row>
            {modalSection()}
        </PageLayout>
    );
}
